/**
 * `submitter` carries the button that triggered the submit: a form whose meaning lives on the button
 * (the status move arrows post `direction`) loses that field otherwise, because `new FormData(form)`
 * only collects named controls.
 */
export function submitDictionaryMutation(form, type, windowRef, fetchImpl, submitter = null) {
    const requestUrl = new URL(form.action, windowRef.location.href);
    requestUrl.searchParams.set('fragment', type);
    const body = new FormData(form);
    if (typeof submitter?.name === 'string' && submitter.name !== '') {
        body.append(submitter.name, String(submitter.value ?? ''));
    }

    return fetchImpl(requestUrl.toString(), {
        method: 'POST',
        body,
        headers: {
            Accept: 'text/html',
            'X-Requested-With': 'XMLHttpRequest',
        },
    });
}
